import {BaseRepository} from "../../../infrastructure/repositories/base-repository";
import {DomUtils} from "../../../infrastructure/utils/dom-utils";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {SiteConfig} from "../../../core/bootstrap/models/site-config";
import {DeviceStore} from "../../../core/app/device.store";
import {EntitiesFactory} from "./entities.factory";
import {EntitiesApi} from "./entities.api";

export class EntitiesRepository extends BaseRepository {
  static injectables = [DomUtils, LoggerUtils, SiteConfig, DeviceStore, EntitiesApi, EntitiesFactory];
}
